import { Link } from "react-router-dom";
import { useDocumentMeta } from "../useDocumentMeta";

const SITE_URL = "https://www.hebiktegenwind.nl";

export function UtrechtAmsterdam() {
  useDocumentMeta({
    title: "Fietsroute Utrecht ↔ Amsterdam | Heb ik tegenwind?",
    description:
      "Pendelen tussen Utrecht en Amsterdam op de fiets? Check hier hoeveel tegenwind en meewind je hebt op de ~45 km route, en hoe je je tocht het beste plant.",
    ogTitle: "Fietsroute Utrecht ↔ Amsterdam | Heb ik tegenwind?",
    ogDescription:
      "Pendelen tussen Utrecht en Amsterdam op de fiets? Check hier hoeveel tegenwind en meewind je hebt op de ~45 km route.",
    canonical: `${SITE_URL}/route/utrecht-amsterdam`,
  });

  return (
    <>
      <h2>Fietsen tussen Utrecht en Amsterdam</h2>
      <p>
        De route Utrecht naar Amsterdam is zo'n 45 km en een klassieke
        forenzenrit voor mensen die liever een dagelijkse buitenrit pakken dan
        de trein. Omdat je grotendeels door open polder fietst speelt wind
        hier een veel grotere rol dan op korte stedelijke ritjes. Een
        zuidwestenwind van 5 Beaufort kan het verschil maken tussen 1u45 en
        2u30 reistijd.
      </p>

      <h3>Windrichting en wat dat betekent voor jouw rit</h3>
      <p>
        De standaard route loopt noordwestelijk, van Utrecht richting
        Amsterdam. De overheersende windrichting in Nederland is zuidwest,
        wat betekent dat je op deze route vaak <strong>zijwind
          richting meewind</strong> hebt. Op de terugweg van Amsterdam naar
        Utrecht is het doorgaans pittiger: dan fiets je met de wind recht
        tegen.
      </p>

      <h3>Populaire varianten van de route</h3>
      <ul>
        <li>
          <strong>Via Abcoude en Vinkeveen:</strong> mooiste en rustigste
          route, volledig over fietspaden en door polder.
        </li>
        <li>
          <strong>Via Breukelen en langs de Vecht:</strong> wat langer, maar
          pittoresk en met iets meer beschutting bij zuidwestenwind.
        </li>
        <li>
          <strong>Snelfietsroute via Maarssen:</strong> rechtste lijn, het
          meest geschikt voor snelle forenzenritjes.
        </li>
      </ul>

      <h3>Tips voor woon-werkfietsers</h3>
      <ul>
        <li>
          Check 's ochtends en 's avonds even het fietsweer. Bij harde wind
          vanuit het zuidwesten kun je overwegen één richting met de trein
          en één richting op de fiets te doen.
        </li>
        <li>
          Denk bij lange tegenwind-ritten aan een{" "}
          <Link to="/">elektrische fiets of trapondersteuning</Link>.
          Tientallen minuten winst per rit.
        </li>
        <li>
          Lees onze{" "}
          <Link to="/tegenwind-tips">tips om slim tegen de wind te fietsen</Link>{" "}
          voor meer besparingen.
        </li>
      </ul>

      <h3>Check deze route in de tool</h3>
      <p>
        Vul <strong>Utrecht</strong> en <strong>Amsterdam</strong> in op de{" "}
        <Link to="/">fietsweer-tool</Link> en zie direct hoeveel procent van de
        route je tegenwind, meewind of zijwind hebt op dit moment.
      </p>

      <h3>Meer fietsweer-informatie per stad</h3>
      <ul>
        <li>
          <Link to="/fietsweer/utrecht">Fietsweer Utrecht</Link>
        </li>
        <li>
          <Link to="/fietsweer/amsterdam">Fietsweer Amsterdam</Link>
        </li>
      </ul>

      <p>
        <Link to="/">← Terug naar de fietsweer-tool</Link>
      </p>
    </>
  );
}
